<template>
  <div class="content-selector-wrapper">
    <RadioGroup
      v-model="model"
      mandatory
      row
      density="compact"
      hide-details
      color="primary"
      class="toolbar-content-selector"
    >
      <Radio
        v-for="option in options"
        :key="option"
        :label="t(option)"
        :value="option"
      >
        {{ t(option) }}
      </Radio>
    </RadioGroup>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import Radio from '@/components/input-components/Radio.vue';
import RadioGroup from '@/components/input-components/RadioGroup.vue';
import { useOrdersStore } from "@/stores/orders";
import { useI18n } from 'vue-i18n'

defineOptions({
  name: 'ToolbarContentSelector'
})

const { t } = useI18n();
const ordersStore = useOrdersStore();

const props = defineProps({
  options: {
    type: Array as () => string[],
    required: true,
  },
})

const emit = defineEmits<{
  (e: 'valueChange', value: 'My Orders' | 'Shared Orders'): void
}>()

const model = computed<'My Orders' | 'Shared Orders'>({
  get: () => ordersStore.getGridContentType || props.options[0] || '',
  set: (val: 'My Orders' | 'Shared Orders') => {
    ordersStore.setGridContentType(val)
    emit('valueChange', val)
  },
})
</script>
<style lang="scss" scoped>
.toolbar-content-selector {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;

  :deep(.v-label) {
    font-size: 1.125rem !important;
  }

  :deep(.v-selection-control-group) {
    flex-direction: row;
  }

  :deep(.v-selection-control) {
    background-color: var(--v-theme-surface);
    border: 1px solid var(--v-theme-on-surface);
    border-radius: 4px;
    padding: 0.5rem 1rem;
    gap: 5px;
  }

  :deep(.v-selection-control .v-label) {
    white-space: nowrap;
  }
}


.content-selector-wrapper {
  display: flex;
  align-items: center;

  .v-input--selection-controls {
    margin-top: 0;
  }

  & > .v-text-field--outlined > .v-input__control > .v-field__input {
    background-color: rgb(var(--v-theme-secondary));
  }
  &
    > .v-text-field--outlined.v-input--is-focused
    > .v-input__control
    > .v-field__input,
  &
    > .v-text-field--outlined.v-input--is-dirty
    > .v-input__control
    > .v-field__input {
    background-color: rgb(var(--v-theme-white));
  }
}
</style>
